<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    v-if="isSidebarActiveLocal"
    ref="frame"
    :class="isSidebarActiveLocal ? 'active' : ''" class="res-product-pop-cont">
    <div tabindex="1">
      <div class="reservation-popup">
        <div class="reservation-header">
          <h2>Reservation Details</h2>
        </div>
        <div class="reservation-details-cont">
          <div class="reservation-res"><h2>Restaurant Name</h2></div>
          <div class="reservation-details">
            <div class="res-det"><i class="far fa-calendar"></i>Mon, Nov 2</div>
            <div class="res-det"><i class="far fa-clock"></i> 11:30 AM</div>
            <div class="res-det"><i class="far fa-user"></i> 2 People</div>
          </div>
        </div>
        <div class="reservation-form">
          <div class="reservation-option two-col complete">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input type="text" placeholder="First Name">
              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input type="text" placeholder="Last Name">
              </div>
            </div>
          </div>
          <div class="reservation-option two-col complete">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input type="phone" placeholder="Phone Number">
              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input type="email" placeholder="Email">
              </div>
            </div>
          </div>
          <div class="reservation-option">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <label>Select an Occasion (Optional)</label>
              </div>
              <div class="reservation-option-section">
                <select>
                  <option>Birthday</option>
                  <option>Anniversary</option>
                  <option>Date Night</option>
                  <option>Business Meal</option>
                  <option>Celebration</option>
                </select>
              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <label>Special Request (Optional)</label>
              </div>
              <div class="reservation-option-section">
                <textarea></textarea>
              </div>
            </div>
          </div>
          <div class="reservation-button">Complete Reservation</div>
          <div class="reservation-terms">
            <p>
              By clicking “Complete Reservation” you agree to the <a href="/terms-of-services" target="_blank">Turkish Restaurant Terms of Service</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>. Standard text message rates may apply. You may opt out of receiving text messages at any time.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
    }
  },
  mounted () {},
  beforeDestroy () {
    this.isSidebarActiveLocal = false
  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        return
      }
      // const {name, id, price, complete_your_meal, description, restaurant_id, size, section, size_id, section_id, hasModifiers, quantity, photoUrl} = JSON.parse(JSON.stringify(this.dataProp))
      return true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
        }
      }
    }
  },
  methods: {
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    }
  }
}
</script>
